/**
 * Created by 2019.3.20
 */
import httpUrl from './baseUrl'//接口地址
import http from './http.js'

//牙科百科列表
export const get_wikis = (get_wikis) =>( http.post_token('xapi/get_wikis',get_wikis));
//相关疾病
export const keywords_types_list = (keywords_types_list) =>( http.post_token('xapi/keywords_types_list',keywords_types_list));
//相关疾病详情
export const keywords_row = (keywords_row) =>( http.post_token('xapi/keywords_row',keywords_row));
//相关视频
export const keywords_videos_list = (keywords_videos_list) =>( http.post_token('xapi/keywords_videos_list',keywords_videos_list));


// WEBPACK FOOTER //
// ./src/components/http/api.js